import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  borderRadius = tokens.borderRadius,
  spacing = tokens.spacing;
var bodyBold = designTokenFonts.bodyBold,
  mini = designTokenFonts.mini;
export var container = /*#__PURE__*/css("display:flex;height:201px;flex-direction:column;width:232px;background-color:", colors.neutral.surface.default, ";border:1px solid ", colors.neutral.trim.default, ";border-radius:", spacing.xs, ";overflow:hidden;flex-shrink:0;cursor:pointer;");
export var cardBody = /*#__PURE__*/css("display:flex;flex-direction:column;height:100%;justify-content:space-between;padding:", spacing.s, ";");
export var nameAddress = {
  name: "a1e6pm",
  styles: "display:flex;overflow:hidden;flex-direction:column;"
};
var _ref = {
  name: "alm2m5",
  styles: "padding-top:8px;padding-left:12px;"
};
export var brandedHeader = _ref3 => {
  var _agency$inclusions, _agency$logoBackgroun;
  var agency = _ref3.agency;
  return /*#__PURE__*/css("display:flex;flex-shrink:0;height:32px;", (agency === null || agency === void 0 ? void 0 : (_agency$inclusions = agency.inclusions) === null || _agency$inclusions === void 0 ? void 0 : _agency$inclusions.brandingLevel) === 'PLATINUM' ? /*#__PURE__*/css("background-color:", (_agency$logoBackgroun = agency === null || agency === void 0 ? void 0 : agency.logoBackgroundColour) !== null && _agency$logoBackgroun !== void 0 ? _agency$logoBackgroun : 'transparent', ";padding-left:16px;align-items:center;border-bottom:1px solid ", colors.neutral.trim.default, ";") : _ref);
};
export var logo = _ref4 => {
  var _agency$inclusions2;
  var agency = _ref4.agency;
  return /*#__PURE__*/css("height:24px;max-width:120px;flex-shrink:0;", (agency === null || agency === void 0 ? void 0 : (_agency$inclusions2 = agency.inclusions) === null || _agency$inclusions2 === void 0 ? void 0 : _agency$inclusions2.brandingLevel) !== 'PLATINUM' && /*#__PURE__*/css("border-radius:", borderRadius.mini, ";"));
};
export var bottom = {
  name: "1187icl",
  styles: "display:flex;flex-direction:row;align-items:flex-start;"
};
var _ref2 = {
  name: "o7rt0f",
  styles: "margin-top:3px;"
};
export var checkbox = _ref5 => {
  var isAgency = _ref5.isAgency;
  return /*#__PURE__*/css(!isAgency && _ref2);
};
export var agencyName = /*#__PURE__*/css(bodyBold, ";color:", colors.neutral.heavy.default, ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var nameTitle = {
  name: "i6bazn",
  styles: "overflow:hidden;"
};
export var agentName = /*#__PURE__*/css("display:-webkit-box;", bodyBold, ";color:", colors.neutral.heavy.default, ";overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
export var jobTitle = /*#__PURE__*/css(mini, ";color:", colors.neutral.medium.default, ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var agent = /*#__PURE__*/css("display:flex;flex-direction:row;gap:", spacing.xs, ";overflow:hidden;");
export var avatar = {
  name: "12nlyhb",
  styles: "flex-shrink:0;width:50px;height:50px;"
};
export var address = /*#__PURE__*/css(mini, ";color:", colors.neutral.medium.default, ";");